import SearchBox from "../search_box/SearchBox";
import Styles from "./Finder.module.scss";
import classnames from "classnames"
import "../dock/iconProvider.css"

//Redux
import { openWindow, closeWindow } from "../../actions";
import { useDispatch } from "react-redux";
import { APP_KEY_IDS } from "../../constants/constants";
import { useState } from "react";
import { DOCK_MENU } from "../dock/Dock";

const Finder = () => {

    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState("")

    return (
        <div className={Styles.finder_container} onClick={() => { dispatch(closeWindow(APP_KEY_IDS.FINDER)) }}>
            <div className={Styles.content_container}>

                <div className={classnames(Styles.search_box_container, "glassBackground")} onClick={(e: any) => { e.stopPropagation() }}>
                    <SearchBox value={searchText} onType={setSearchText} size={"large"} placeholder={"Spotlight Search"} />
                </div>
                <div className={classnames(Styles.search_container, "glassBackground")}>
                    {
                        DOCK_MENU.filter((item: any) => {
                            if (String(item.label).toLowerCase().includes(searchText.toLowerCase())) {
                                return true
                            }
                        }).map((app) => {
                            return (
                                <div className={Styles.app_card} onClick={()=>{dispatch(openWindow(app.id))}} key={app.id}>
                                    <div className={Styles.app_icon} id={app.id} ></div>
                                    <div className={Styles.app_label}>
                                        {app.label}
                                    </div>
                                </div>
                            )
                        })
                    }

                    
                </div>
            </div>
        </div>
    )
}

export default Finder
